import { useContext } from "react";
import { TestContext } from "../../store/testContext";
import { FlexCol } from "src/utils/flexLayouts";
import TGTag from "src/components/ui/TGTag";
import { twMerge } from "tailwind-merge";

export default function TestsHeader() {
  const {
    state: { Questions }
  } = useContext(TestContext);

  return (
    <header className="text-[#111928] pt-10 pb-8 space-x-5">
      <div className="flex flex-row items-center space-x-5">
        <FlexCol>
          <h1>Тестирование</h1>
        </FlexCol>
        <FlexCol>
          <TGTag className={twMerge(Questions.length > 0 ? "text-[#111928]" : "text-[#a0a3a9]", "translate-y-1")} color={Questions.length > 100 ? "red" : "gray"}>
            Вопросов: {Questions.length}
            {!Questions.length ? ",не требуется" : null}
          </TGTag>
        </FlexCol>
      </div>
    </header>
  );
}
